import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// GA4's base snippet only fires a page_view on the initial script load —
// client-side route changes in this SPA never reload the page, so without
// this, GA4 would only ever see a visitor's entry page and nothing else
// they navigate to. send_page_view is disabled in the base snippet
// (index.html) so this is the single source of page_view events. Meta
// Pixel's PageView is tracked the exact same way, for the same reason —
// its own base code (index.html) deliberately skips firing it on load, so
// this is that single source for both.
const PageViewTracker = () => {
  const location = useLocation();

  useEffect(() => {
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: location.pathname + location.search,
        page_location: window.location.href,
        page_title: document.title,
      });
    }

    if (typeof window.fbq === "function") {
      window.fbq("track", "PageView");
    }
  }, [location]);

  return null;
};

export default PageViewTracker;
